import React from "react"
import Studio from "features/studio/Studio"
import WithBlocks from "data/wrappers/WithBlocks"
import BlockTable from "features/studio/components/BlockTable"
import PageTitle from "ui/components/PageTitle"
import Breadcrumbs from "ui/components/Breadcrumbs"

// import RecordTable from "features/studio/components/RecordTable"
import NewBlockButton from "../components/NewBlockButton"
import { Container, Section } from "ui"
import WithApps from "data/wrappers/WithApps"

export default class BlockListPage extends React.Component {
    render() {
        return (
            <Studio color="red">
                <Container marginBottom="medium" spaced>
                    <Section margin="none" padding="none">
                        <Breadcrumbs crumbs={[{ label: "Design" }]} />
                        <PageTitle>Blocks</PageTitle>
                    </Section>{" "}
                    <NewBlockButton />
                </Container>

                <WithApps>
                    {({ selectedApp }) => (
                        // <RecordTable filters={{ app_id: selectedApp._sid }} objectId={"blocks"} />
                        //
                        <WithBlocks>
                            {({ blocks, onChange }) => (
                                <BlockTable onChange={onChange} data={blocks} />
                            )}
                        </WithBlocks>
                    )}
                </WithApps>
            </Studio>
        )
    }
}



// WEBPACK FOOTER //
// ./src/features/studio/containers/BlockListPage.js